export function DecriptEnv(wrappedKey: any) {
  if (!wrappedKey) {
    return "";
  }
  if (typeof wrappedKey !== "string")
    throw new TypeError("wrappedKey must be a string");

  if (wrappedKey.length <= 8) throw new Error("wrappedKey too short to unwrap");

  // Step 1: Remove first 4 and last 2
  const trimmed = wrappedKey.slice(4, -2);

  // Step 2: Remove original index 6 and 7 (which are now at index 2 and 3 in trimmed)
  const result = trimmed.slice(0, 2) + trimmed.slice(4);

  return result;
}

export const responseEncrypted = process.env.REACT_APP_IS_ENCRYPTED;
export const secretKey: string = DecriptEnv(
  process.env.REACT_APP_ENCRYPT_KEY || "",
);
